import React from "react";

interface CardProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  bodyPadding?: boolean;
  /** Grid-Span im 12-spaltigen Dashboard-Grid. Setzt inline style für robusten
   *  Effekt auch ohne CSS-Klassen. */
  gridSpan?: number;
  children: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  actions,
  className = "",
  style,
  bodyPadding = true,
  gridSpan,
  children,
}) => {
  const showHead = title !== undefined || actions !== undefined;
  const mergedStyle: React.CSSProperties = {
    ...(gridSpan ? { gridColumn: `span ${gridSpan}` } : {}),
    ...style,
  };
  return (
    <div className={"ds-card " + className} style={mergedStyle}>
      {showHead && (
        <div className="ds-card-head">
          <div style={{ display: "flex", flexDirection: "column", gap: 2, flex: 1, minWidth: 0 }}>
            {title && <h3 className="ds-card-title">{title}</h3>}
            {subtitle && (
              <div style={{ fontSize: 11, color: "var(--ds-text-3)" }}>{subtitle}</div>
            )}
          </div>
          {actions && (
            <div style={{ display: "flex", gap: 8, alignItems: "center", flexShrink: 0, flexWrap: "wrap" }}>
              {actions}
            </div>
          )}
        </div>
      )}
      <div
        className={bodyPadding ? "ds-card-body" : ""}
        style={bodyPadding ? undefined : { padding: 0 }}
        suppressHydrationWarning
      >
        {children}
      </div>
    </div>
  );
};
